import axios from "axios";
import { useEffect, useRef, useState } from "react"
import Select from "react-dropdown-select";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { acceptedTags, MajorColorArrays, ColorMapping, patterns, textures, FemaleTrendToStlCategory, MaleTrendToStlCategory, metaCategoryTags, valuesThumbnails, RecommendationDropdownValues, RecommendationArgumentDropdownValues, EdgynComfortOptions } from '../../constants'
import { metaCategories, metaTags } from "../../constants";
import AdditionalDataUpdate from "./AdditionalDataUpdate";
import AmazonAsinIds from "./AmazonAsinIds";
import SimilarProductsTabular from "./SimilarProductsTabular";
import StickyTagsUpdatePopup from "./StickyTagsUpdatePopup";
import STLValuesUpdate from "./STLValuesUpdate";
import TrendingColorsTable from "./TrendingColorOptionsTable";

function TagsUpdatePopup({ mediaId, isPage, setAllTagsFilled, allTagsFilled }) {

  const [imageData, setImageData] = useState(null)
  const { userLoggedIn } = useSelector(state => state)
  const [category, setCategory] = useState('')
  const [errorMessage, setErrorMessage] = useState(null)
  const [categoriesUsed, setCategoriesUsed] = useState([])
  const [tag, setTag] = useState(null);
  const [values, setValues] = useState([]);
  const [categoryTags, setCategoryTags] = useState([])
  const [valuesToUpdate, setValuesToUpdate] = useState({ tagValues: [], ASIN: [] });
  const [isDataLoading, setIsLoading] = useState(false)
  const [tagsRemaining, setTagsRemaining] = useState([])
  const [isCoordSelected, setIsCoordSelected] = useState(false)
  const [color, setColor] = useState('')
  const [brands, setBrands] = useState([])
  const [seasonalcategoryMetadata, setSeasonalcategoryMetadata] = useState({})

  const getImageData = () => {
    setIsLoading(true)
    axios.get(`/images-meta-api/image-data/${mediaId}`).then(response => {
      setImageData(response.data)
      setIsLoading(false)
    })
  }

  const updateSeasonalCategoryfield = (tag, values) => {
    axios.post(`/images-meta-api/add-seasonal-values/${mediaId}`, { tag, values, category }).then(response => {
      getImageData()
    })
  }

  const getBrands = () => {
    axios.get(`/images-meta-api/all-brands`, { tag, values, category }).then(response => {
      setBrands(response.data.brands)
    })
  }

  useEffect(() => {
    getBrands()
  }, [])

  useEffect(() => {
    if (!userLoggedIn.curator && categoriesUsed.length > 0) {
      setCategory(categoriesUsed[0])
    }
  }, [categoriesUsed])

  useEffect(() => {
    if (imageData && imageData.tagsArray) {
      const catsObj = {}
      imageData.tagsArray.forEach(c => {
        catsObj[c.category] = true
        const catsArraayTemp = metaCategories.filter(c => catsObj[c])
        setCategoriesUsed(catsArraayTemp)
      })
    } else {
      setCategoriesUsed([])
    }
  }, [imageData])

  useEffect(() => {
    if (!setAllTagsFilled) {
      return
    }
    if (!tagsRemaining || tagsRemaining.length == 0) {
      setAllTagsFilled(true)
    } else {
      setAllTagsFilled(false)
    }
  }, [tagsRemaining])

  const updateGender = (gender) => {
    axios.post(`/images-meta-api/update-gender/${mediaId}`, { gender }).then(response => {
      getImageData()
    })
  }

  const deleteImage = () => {
    axios.delete(`/images-meta-api/delete-image/${mediaId}`).then(response => {
      Swal.fire({ text: "Image Deleted Successfully." })
      getImageData()
    })
  }

  useEffect(() => {
    setValues(prev => {
      if (imageData && imageData.tagsArray) {
        const matchingValues = imageData.tagsArray.filter(el => el.category == category && el.tag == tag)
          .map(el => el.value)
        return matchingValues
      }
      return []
    })
  }, [tag, category, imageData])

  useEffect(() => {
    if (!imageData) {
      return
    }
    const tagsList = new Set(metaCategoryTags[category]);
    if (imageData.tagsArray) {
      imageData.tagsArray.forEach(t => {
        if (t.category == category) {
          tagsList.delete(t.tag)
        }
      })
    }
    setTagsRemaining([...tagsList.values()])

    if (imageData && imageData.seasonalMetadata) {
      const categorySeasonalMetadata = imageData.seasonalMetadata.filter(d => d.category == category) ? imageData.seasonalMetadata.filter(d => d.category == category)[0] : {}
      setSeasonalcategoryMetadata(categorySeasonalMetadata)
    } else {
      setSeasonalcategoryMetadata({})
    }
  }, [category, imageData])

  useEffect(() => {
    const tagsTemp = {}
    const isCoordObj = {}
    if (imageData && imageData.tagsArray) {
      imageData.tagsArray.forEach(r => {
        if (r.category == category) {
          if (!tagsTemp[r.tag])
            tagsTemp[r.tag] = []
          tagsTemp[r.tag].push(r.value)
          if (r.isCoord) {
            isCoordObj[r.tag] = true
          }
        }
      })
      const newTagsArray = []
      for (let k in tagsTemp) {
        newTagsArray.push({ tag: k, values: tagsTemp[k], isCoord: isCoordObj[k] })
      }
      setCategoryTags(newTagsArray)
    } else {
      setCategoryTags([])
    }
  }, [category, imageData])

  useEffect(() => {
    setTag(null)
  }, [category])

  useEffect(() => {
    if (!mediaId) return
    getImageData();
  }, [mediaId])

  useEffect(() => {
    if (errorMessage && category) {
      setErrorMessage(null)
    }
  }, [category])

  const updateValues = () => {
    setIsLoading(true)
    axios.post(`/images-meta-api/add-bulk-values/${mediaId}`, valuesToUpdate).then(response => {
      setValuesToUpdate(prev => {
        const newValues = { ...prev }
        newValues.tagValues = []
        newValues.ASIN = []

        return newValues;
      })
      getImageData()
    })
  }

  const addValues = () => {
    if (!category || category == "") {
      setErrorMessage("No Category Selected.")
      return
    }
    setValuesToUpdate(prev => {
      const returnValues = { ...prev }
      const tagValues = returnValues.tagValues
      const categoryTagValuesArray = tagValues.filter(c => c.category == category)
      let categoryTagsObject = categoryTagValuesArray[0]
      if (!categoryTagsObject) {
        categoryTagsObject = { category, tags: [] }
        tagValues.push(categoryTagsObject);
      }

      const TagValuesArray = categoryTagsObject.tags
      const filteredTagValuesArray = TagValuesArray.filter(t => t.tag == tag)
      let TagsObject = filteredTagValuesArray[0]
      if (TagsObject) {
        TagsObject.values = values
      } else {
        TagsObject = { tag, values }
        TagValuesArray.push(TagsObject);
      }
      return returnValues;
    })
    return;
  }

  useEffect(() => {
    if (tag) {

      if (imageData && imageData.tagsArray) {
        const matchingValues = imageData.tagsArray.filter(el => el.category == category && el.tag == tag)
          .map(el => el.value)

        if (values[0] == matchingValues[0] && values[1] == matchingValues[1]) {
          return;
        }
      }
      if (values.length == 0 && !imageData.tagsArray)
        return;
      addValues()
    }
  }, [values])


  useEffect(() => {
    if (category != 'Coords') {
      setIsCoordSelected(false)
      return
    }

    const arr = imageData?.tagsArray?.filter(t => t.category == 'Coords' && t.tag == tag)
    if (arr.length == 0) {
      setIsCoordSelected(false)
      return
    }
    setIsCoordSelected(arr[0].isCoord)
  }, [tag])


  const updateIsCoord = (tag, category, isCoord) => {
    axios.post(`/images-meta-api/coord/${mediaId}`, { tag, category, isCoord }).then(response => {
      getImageData()
    })
  }

  const flipCategoryCoord = (category) => {
    axios.post(`/images-meta-api/flip-category-coord/${mediaId}`, { category }).then(response => {
      getImageData()
    })
  }

  return (
    <div className={`${isPage ? "w-full" : "w-[80vw] h-[78vh]"} overflow-auto flex flex-row flex-wrap ${userLoggedIn.curator ? '' : 'mt-8'}`}>
      {userLoggedIn.curator && <div className="w-full flex justify-end shrink-0 p-2 px-4 border-b border-b-slate-700 h-12">
        <div className="px-4 text-sm font-semibold ">{imageData ? imageData.curator : null}</div>
        <button onClick={() => {
          window.navigator.clipboard.writeText(`${window.location.origin}/curator-meta-tags/${mediaId}`)
        }} className="px-2 py-1 rounded bg-slate-600 active:bg-slate-700 hover:bg-slate-800 text-white text-sm">Copy Url</button>
      </div>}
      {imageData && <>
        <div className={`${userLoggedIn.curator ? 'lg:w-2/5 ' : 'lg:w-1/2'} w-full shrink-0 border-r-2 border-slate-300 `}>
          <img className="max-h-[80vh] mx-auto" src={imageData.imageUrl} />
          <hr />
          <div className="font-medium text-xs">TimeStamp :{new Date(imageData.timeStamp).toLocaleString()}</div>
          <AdditionalDataUpdate userLoggedIn={userLoggedIn} category={category} type={'social'} imageData={imageData} seasonalcategoryMetadata={seasonalcategoryMetadata} updateSeasonalCategoryfield={updateSeasonalCategoryfield} values={values} />
        </div>
        {!isDataLoading ? <div className={`${userLoggedIn.curator ? 'lg:w-2/5' : 'lg:w-1/2'} w-full px-6 shrink-0 ${userLoggedIn.curator ? 'mb-[10vh]' : 'mb-10'}`}>
          {userLoggedIn && userLoggedIn.admin ? <div className="flex p-2">
            <button className="bg-red-600 hover:bg-red-700 active:bg-red-800 disabled:bg-red-400 rounded text-white px-2 py-1 font-semibold" disabled={imageData.deleted} onClick={deleteImage}>DELETE IMAGE</button>
          </div> : null}
          {userLoggedIn.curator && <div className="flex w-full py-2 text-xs  mb-4 ">
            <button className={`rounded-l border-r-0 px-4 py-1 ml-4 font-semibold border-slate-400 hover:bg-slate-100 border  outline-none hover:shadow ${imageData.gender == 'M' ? 'bg-slate-600 text-white hover:bg-slate-800' : ""}`} disabled={imageData.gender == 'M'} onClick={() => { updateGender("M") }}>Male</button>
            <button className={`rounded-r border-l-0 px-4 py-1 mr-4 font-semibold border-slate-400 hover:bg-slate-100 border  outline-none hover:shadow ${imageData.gender == 'F' ? 'bg-slate-600 text-white hover:bg-slate-800' : ""}`} disabled={imageData.gender == 'F'} onClick={() => { updateGender("F") }}>Female</button>

            {
              imageData.gender &&
              <select id="update-tags-category" value={category} onChange={(e) => { setCategory(e.target.value) }} className='p-2'>
                <option value='' >--select subcategory--</option>
                {metaCategories.sort().map(cat => < option value={cat} >{cat}</option>)}
              </select>
            }
          </div>
          }
          <div className='mt-4'>
            <div className="flex  w-full overflow-x-auto border-b border-slate-500">
              {
                categoriesUsed.map((cat, i) => <button key={cat} className={`px-2 pt-1 py-1 rounded-t border-slate-300 ${cat == category ? 'bg-slate-700 text-white hover:bg-slate-900' : 'border border-slate-700 border-b-0 hover:bg-slate-50 bg-white'}`} onClick={() => setCategory(cat)}>{cat}</button>)
              }
            </div>
            <div className="flex flex-wrap">

              {
                userLoggedIn.curator && category &&
                <>
                  <h3>Select tag</h3>
                  <div className="w-full flex flex-wrap py-2">
                    <button className={`px-1 py-0.5 m-0.5 text-xs rounded border border-slate-600 shrink-0 group ${'COLOR' == tag ? 'text-white bg-slate-600' : tagsRemaining.includes('COLOR') ? 'text-black bg-red-200' : 'text-black bg-white'}`} onClick={() => setTag('COLOR')}
                    >COLOR</button>
                    {(metaCategoryTags[category] ? metaCategoryTags[category].filter(it => it != 'MODESTY LEVEL' || imageData.gender != 'M').sort() : []).map(t => <button className={`px-1 py-0.5 m-0.5 text-xs rounded border border-slate-600 shrink-0 group ${t == tag ? 'text-white bg-slate-600' :
                      valuesToUpdate.tagValues && valuesToUpdate.tagValues.filter(c => c.category == category).length > 0 && valuesToUpdate.tagValues.filter(c => c.category == category)[0].tags.filter(savedTag => savedTag.tag == t).length > 0
                        ? " bg-red-600 text-white "
                        : tagsRemaining.includes(t) ? 'text-black bg-red-200' : 'text-black bg-white'}`} onClick={() => setTag(t)}>{t}<div className="w-0 h-0 relative">
                      </div>
                    </button>)}

                  </div>
                </>
              }

              {tag &&
                <h3>{tag} values </h3>
              }
              <div className="w-full flex flex-wrap py-2">
                {
                  tag && tag != 'COLOR' &&
                  metaTags[tag].map(t => <button className={`px-1 py-0.5 m-0.5 group shrink-0 text-xs rounded border border-slate-600 ${values.includes(t) ? 'text-white bg-slate-600' : 'text-black bg-white'}`} onClick={() => setValues(prev => {
                    if (prev.includes(t)) {
                      return prev.filter(p => p != t)
                    }
                    if (prev.length >= 2) {
                      return [prev.pop(), t]
                    }
                    return [...prev, t]
                  })}>{t}<div className="w-0 h-0 ">
                      <div className="invisible fixed group-hover:visible h-80 w-[95vw] border border-slate-600 top-[55vh] left-10 bg-white opacity-100 py-2 border-b-8 border-b-slate-200">
                        {valuesThumbnails[tag] && valuesThumbnails[tag][t] ? <>
                          <h3 className="text-center h-1/5 font-semibold text-2xl pt-4">{valuesThumbnails[tag][t].description}</h3>
                          <img src={valuesThumbnails[tag][t].thumbnail} className="w-full h-4/5" />
                        </> : null}
                      </div> </div>
                  </button>)
                }
                {
                  tag &&
                  tag == 'COLOR' &&
                  <div className="">
                    <Select values={values.map(v => ({ value: v }))}
                      placeholder='Select Color'
                      onChange={next => {
                        if (next.length > 2) {
                          next = next.slice(next.length - 2)
                        }
                        setValues(prev => {
                          return next.map(v => v.value)
                        })
                      }}
                      multi={true}
                      labelField='value'
                      valueField='value'
                      className="w-40"
                      key={values.join('-')}
                      options={
                        Object.keys(MajorColorArrays).sort().map(c => ({ value: c }))
                      }
                    />
                  </div>
                }

              </div>
            </div>
          </div>

          {errorMessage && <p className="font-semibold text-red-400">{errorMessage}</p>}

          <h3 className="text-2xl my-3 font-semibold text-center w-full ">{category}{userLoggedIn.curator && <button className={`px-2 py-1 border ml-1 text-sm rounded ${imageData && imageData.Coords && imageData.Coords.includes(category) ? 'border-slate-600 bg-slate-600 text-white' : 'border-black bg-white text-black'}`}
            onClick={() => {
              flipCategoryCoord(category);
            }}
          >{imageData && imageData.Coords && imageData.Coords.includes(category) ? 'Remove Coord' : 'Add Coord'}</button>
          }</h3>

          <div className="w-full h-full min-h-[300px]">
            <div className="">
              {categoryTags.sort((a, b) => a.tag - b.tag)
                .filter(c => (userLoggedIn.curator || (c && c.values && c.values[0] != '#N/A'))).map((c, i) => <div key={c.tag} className="my-3">
                  <h3 className="font-semibold ">{i + 1}.{c.tag}{userLoggedIn.curator && <button className={`px-2 py-1 border text-xs rounded ${c.isCoord ? 'border-slate-600 bg-slate-600 text-white' : 'border-black bg-white text-black'}`} onClick={() => { updateIsCoord(c.tag, category, !c.isCoord) }}>{c.isCoord ? 'Remove Coord' : 'Add Coord'}</button>}</h3>
                  {(c.tag == 'COLOR' ? c.values.slice(0, 1) : c.values).map((v, j) => <p className="text-xs pl-4" key={j}>{j + 1}. {v}</p>)}
                </div>)}
              {
                categoryTags && categoryTags.filter(c => c.tag == 'COLOR')
                  .map(c => <div key={c.tag} className="my-3">
                    <h3 className="font-semibold ">{categoryTags.filter(c => (userLoggedIn.curator || (c && c.values && c.values[0] != '#N/A'))).length + 1}.MULTICOLOR</h3>
                    <p className="text-xs pl-4" key={0}>1. {c.values.join('/')}</p>
                  </div>)
              }
            </div>
          </div>
        </div>
          : null}

        {
          userLoggedIn.curator ? <StickyTagsUpdatePopup
            updateValues={updateValues}
            isDataLoading={isDataLoading}
            valueToUpdate={valuesToUpdate}
            setValuesToUpdate={setValuesToUpdate}
          />
            : null
        }

        {
          userLoggedIn.curator ? <STLValuesUpdate
            updateValues={updateValues}
            type="social"
            valuesToUpdate={valuesToUpdate}
            setValuesToUpdate={setValuesToUpdate}
            imageData={imageData}
          />
            : null
        }
      </>}

      {userLoggedIn.curator && category ? <div className="w-full p-2 px-4 border-b border-t-slate-700  overflow-x-auto">
        <SimilarProductsTabular imageData={imageData} mediaId={mediaId} category={category} getImageData={getImageData} getBrands={getBrands} brands={brands} />
        <TrendingColorsTable imageData={imageData} mediaId={mediaId} category={category} getImageData={getImageData} getBrands={getBrands} brands={brands} />
        <AmazonAsinIds
          imageData={imageData}
          mediaId={mediaId}
          category={category}
          valueToUpdate={valuesToUpdate}
          updateValues={updateValues}
          isDataLoading={isDataLoading}
          setValuesToUpdate={setValuesToUpdate}
        />
      </div> : null}
    </div >
  )

}

export default TagsUpdatePopup
